module.exports = __webpack_public_path__ + "static/media/servicios.79da8e87.jpg";